import styled from "@emotion/styled";
import { Section } from "../StyledComponent";

export const StyledErrorPage = styled(Section)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  gap: 24px;
`;
